import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

import MobileContext, { IMobileContext } from "./context";

const MobileState: React.FC = (props) => {
  const initial = useMediaQuery({ query: "(max-width: 900px)" });
  const [mobileState, setMobileState] = useState<IMobileContext>({
    isMobile: initial,
  });

  const handleWidthTrigger = (matches: boolean) => {
    setMobileState({ ...mobileState, isMobile: matches });
  };

  useMediaQuery({ query: "(max-width: 900px)" }, undefined, handleWidthTrigger);

  return (
    <MobileContext.Provider
      value={{
        isMobile: mobileState.isMobile,
      }}
    >
      {props.children}
    </MobileContext.Provider>
  );
};

export default MobileState;
